var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 100.7",
    style: {
      enableBackground: "new 0 0 101 100.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B3B3B3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.7,70.4c3.2-7.1,4.6-15,4.2-22.7c-0.4-7.8-2.7-15.4-6.6-22.2C89.5,18.7,84,12.9,77.5,8.7 C70.9,4.5,63.4,1.8,55.7,1c0,0-0.1,0-0.1,0c-0.5,0-0.9,0.4-1,0.9c-0.1,0.5,0.3,1,0.9,1.1c7.4,0.8,14.6,3.3,20.9,7.4 c6.3,4.1,11.5,9.6,15.3,16.1c3.7,6.5,5.9,13.8,6.3,21.3c0.4,7.4-1,15-4,21.8c-0.1,0.2-0.1,0.5,0,0.8c0.1,0.2,0.3,0.4,0.5,0.6 C94.8,71.1,95.5,70.9,95.7,70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,79.2c4.5,6.3,10.6,11.5,17.5,15.1c6.9,3.6,14.7,5.5,22.4,5.5h0.2c7.7,0,15.4-1.8,22.3-5.3 c6.9-3.5,13-8.7,17.6-14.9c0.3-0.4,0.2-1.1-0.2-1.4c-0.4-0.3-1.1-0.2-1.4,0.2c-4.4,6-10.3,11-16.9,14.3c-6.6,3.3-14,5.1-21.4,5.1 h-0.2c-7.4,0-14.9-1.9-21.5-5.3c-6.6-3.4-12.4-8.4-16.8-14.5c-0.2-0.3-0.5-0.4-0.8-0.4c-0.2,0-0.4,0.1-0.6,0.2 C10.1,78.1,10,78.7,10.3,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,10.4C30.9,6.3,38.1,3.8,45.5,3c0.5-0.1,1-0.6,0.9-1.1c-0.1-0.5-0.5-0.9-1-0.9c0,0-0.1,0-0.1,0 c-7.7,0.8-15.3,3.5-21.8,7.7c-6.5,4.2-12,10-15.9,16.8C3.7,32.2,1.5,39.9,1,47.6c-0.4,7.8,1,15.6,4.2,22.7c0.2,0.5,0.8,0.7,1.3,0.5 c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.1-0.5,0-0.8c-3-6.8-4.4-14.4-4-21.8c0.4-7.5,2.6-14.8,6.3-21.3C13.1,20,18.4,14.5,24.6,10.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleThin);
export default __webpack_public_path__ + "static/media/circle_thin.a99103f9e0b480113ae87f29f4590a7a.svg";
export { ForwardRef as ReactComponent };